import { Component } from '@angular/core'
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog'

@Component({
  selector: 'app-invalid-list',
  templateUrl: './invalid-list.component.html',
  styleUrls: ['./invalid-list.component.scss'],
})
export class InvalidListComponent {
  public invalidDataList: Array<{ line: number; error: string }>

  constructor(
    private dialogConfig: DynamicDialogConfig,
    public ref: DynamicDialogRef,
  ) {
    this.invalidDataList = this.dialogConfig.data.errorList
  }

  close() {
    this.ref.close()
  }
}
